module.exports = __webpack_public_path__ + "c47d8a98ce0a91eba0b40553ee112944.svg";